import { Component, Input } from '@angular/core';
import { UpsellFaq } from 'src/app/models/upsellFaq';

@Component({
    selector: 'upsell-faq',
    templateUrl: 'upsell-faq.html',
    styleUrls: ["upsell-faq.scss"],
    standalone: false
})
export class UpsellFaqsComponent {
  @Input() upsellFaqTitle = 'Frequently Asked Questions';
  @Input() upsellFaqContent: Array<UpsellFaq> = [];

  expandedItems = new Set<number>();

  toggleFaq(index: number): void { 
    if (this.expandedItems.has(index)) {
      this.expandedItems.delete(index);
    } else {
      this.expandedItems.add(index);
    }
  }

  isExpanded = (index: number): boolean => this.expandedItems.has(index);
}
